import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

// Selectors
import { selectCustomerFirstName, selectCustomerHasSponsor } from '../../../../store/selectors/customerProfile'
import { selectSponsorshipFullName } from '../../../../store/selectors/sponsorship'

// Components
import { If, Text } from '../../..'
import CospoAvatars from './CospoAvatars'

// Styles
import styles from './CospoIntro.module.scss'

const CospoIntro = ({ children, footerId }) => {
  const hasSponsor = useSelector(selectCustomerHasSponsor)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const sponsorFullName = useSelector(selectSponsorshipFullName)

  const endPunctuation = children ? ':' : '.'

  const handleNavigateFooter = () => {
    const element = document.getElementById(footerId)
    element.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <If condition={hasSponsor}>
      <div className={styles.cospoIntro}>
        <CospoAvatars />
        <Text variant='neutralCool' variantCount='700' size='s'>
          <FormattedMessage
            id='Refinance.details.cospoIntro'
            defaultMessage='Learn more about refinancing from {sponsor}, a lender {customer} trusts{endPunctuation}'
            values={{
              customer: customerFirstName,
              endPunctuation,
              sponsor: (
                <span role='button' tabIndex='0' onClick={handleNavigateFooter} onKeyPress={handleNavigateFooter}>
                  <Text
                    className={styles.sponsorLink}
                    element='span'
                    variant='secondary'
                    variantCount='600'
                    weight='bold'
                  >
                    {sponsorFullName}
                  </Text>
                </span>
              )
            }}
          />
        </Text>

        {children}
      </div>
    </If>
  )
}

CospoIntro.propTypes = {
  children: PropTypes.any,
  footerId: PropTypes.string
}
export default CospoIntro
